import axios from '@/utils/request';

let prefix = process.env.VUE_APP_API_PREFIX_2;

// 获取token
const getToken = params => {
  return axios.get(prefix + '/getToken');
};

// 根据token获取用户信息
const GetInfoByToken = params => {
  return axios.get(prefix + '/GetInfoByToken');
};

export { getToken, GetInfoByToken };
